import React, { Component } from "react";
import moment from "moment";
import { Select, Input, DatePicker, Button, Icon, message } from "antd";
import { searchOrder, exportOrder } from "../../../features/home/api";
import Sidebar from "./Sidebar";
import NavBar from "../../../features/nav/NavBar/NavBar";
import Table from "../../../features/home/tabView/table/Table";
import Paginater from "../../../features/home/tabView/table/Paginater";
import {
  getEmployeeList,
  getDistributorList,
  getRetailerList,
  getDispatchList,
  getLnamList,
  getCustomerList,
  getCoatingList,
  getProductGroupMasterList,
} from "../../../features/orderPunching/formUtils";
import {
  renderLnamCell,
  renderReferenceIdCell,
  renderDateTimeCell,
  renderCoatingCell,
  renderOrderNumberCell,
} from "../../../features/home/tabView/table/orderTableCells";
import { connect } from "react-redux";
import {
  fetchOnHoldOrders,
  onHoldStatusChange,
  getOrderDetailsForPage,
  getOrderDetailsForForm,
} from "../../../features/home/homeActions";
import { openModal } from "../../../features/modal/modalActions";
import { labelDataApiCall } from "../../../features/orderLabelling/api";
import { errorToast, successToast, getUserPermissions } from "./genericUtils";
import { reportError } from "./sentryConfig";
import { PermissibleRender } from "@brainhubeu/react-permissible";
import SimplePageLoader from "./SimplePageLoader";
const Option = Select.Option;

// Constants
const SEARCH_TYPES = [
  { label: "Order No", value: "order_no", requiredPermissions: [] },
  { label: "Reference Id", value: "reference_id", requiredPermissions: [] },
  { label: "External Id", value: "external_id", requiredPermissions: [] },
  { label: "Product Group", value: "product_group", requiredPermissions: [] },
  { label: "Coating Id", value: "coating_id", requiredPermissions: [] },
  { label: "Lnam Id", value: "lnam_id", requiredPermissions: [] },
  { label: "Customer Id", value: "customer_id", requiredPermissions: [] },
  {
    label: "M Accn",
    value: "m_accn",
    requiredPermissions: ["can_search_maccn"],
  },
  { label: "Distributor Id", value: "distributor_id", requiredPermissions: [] },
  { label: "Author Id", value: "author_id", requiredPermissions: [] },
  { label: "Retailer Id", value: "retailer_id", requiredPermissions: [] },
  {
    label: "Dispatch Type Id",
    value: "dispatch_type_id",
    requiredPermissions: [],
  },
  { label: "All", value: "all_orders", requiredPermissions: [] },
  { label: "Label", value: "label", requiredPermissions: [] },
];
const STATUS_TYPES = [
  { label: "On Hold", value: "on_hold" },
  { label: "Authorization", value: "pending_auth" },
  { label: "Processing", value: "processing" },
  { label: "All", value: "all" },
];
const DEFAULT_PAGE_SIZE = 40;

const PLACEHOLDER_MAPPING = {
  order_no: "Enter order number",
  reference_id: "Enter reference id",
  external_id: "Enter external id",
  m_accn: "Enter MACCN",
};

// Component
class SearchOrders extends Component {
  state = {
    selectedSearchType: null,
    areSecondarySearchFieldsActive: false,
    startDate: "",
    endDate: "",
    selectedSearchValue: "",
    orderStatus: STATUS_TYPES[0].value,
    orders: {},
    loading: false,

    author_id_list: [],
    customer_id_list: [],
    dispatch_type_id_list: [],
    lnam_id_list: [],
    coating_id_list: [],
    distributor_id_list: [],
    retailer_id_list: [],
    label_list: [],
    product_group_list: [],
  };
  columns = [
    {
      title: "Order No.",
      dataIndex: "internal_order_id",
      sorter: (a, b) => a.internal_order_id - b.internal_order_id,
      sortDirections: ["ascend", "descend"],
      render: (text, record, index) =>
        renderOrderNumberCell(text, record, () => {
          if (this.state.orderStatus === "pending_auth") {
            this.props.getOrderDetailsForForm(record.id, index);
          } else {
            this.props.getOrderDetailsForPage(record.id, index);
          }
        }),
    },
    {
      title: "Reference Id",
      dataIndex: "reference_id",
      render: renderReferenceIdCell,
    },
    {
      title: "External Order Id",
      dataIndex: "external_order_id",
      mobileHidden: true,
      render: (text) =>
        text ? (
          <span className="order-ref-id">{text}</span>
        ) : (
          <span className="order-cell-muted">—</span>
        ),
    },
    {
      title: "Entry Date & Time",
      dataIndex: "received_date",
      sorter: (a, b) =>
        new Date(b.received_date) - new Date(a.received_date),
      sortDirections: ["ascend", "descend"],
      render: renderDateTimeCell,
    },
    {
      title: "Coating",
      dataIndex: "coating.value",
      mobileHidden: true,
      render: renderCoatingCell,
    },
    {
      title: "LNAM",
      dataIndex: "lnam.name",
      mobileHidden: true,
      render: renderLnamCell,
    },
    {
      title: "Customer",
      dataIndex: "customer.name",
      mobileHidden: true,
    },
    {
      title: "Actions",
      fixed: "right",
      width: 120,
      className: "order-actions-column",
      mobileHidden: true,
      render: (text, record) => {
        return this.state.orderStatus === "on_hold" ? (
          <div className="order-actions-icons">
            <Icon
              type="check"
              className="tick-icon"
              onClick={() => this.props.onHoldStatusChange(record.id)}
            />
            <Icon
              type="close"
              className="cross-icon"
              onClick={() =>
                this.props.openModal("CancellationModal", {
                  record,
                  actions: ["fetchOnHoldOrders"],
                })
              }
            />
          </div>
        ) : (
          <span className="order-cell-muted">—</span>
        );
      },
    },
  ];
  async componentDidMount() {
    this.setState({
      author_id_list: getEmployeeList(),
      dispatch_type_id_list: getDispatchList(),
      lnam_id_list: getLnamList(),
      customer_id_list: await getCustomerList(),
      coating_id_list: getCoatingList(),
      distributor_id_list: await getDistributorList(),
      retailer_id_list: await getRetailerList(),
      product_group_list: await getProductGroupMasterList(),
    });
    this.getLabelData();
  }
  transFormLabelData = (data) => {
    let labelList = [];
    data.forEach((label) => {
      let labelItem = {
        key: label.short_code,
        label: label.long_code,
      };
      labelList.push(labelItem);
    });
    return labelList;
  };
  getLabelData = async () => {
    labelDataApiCall()
      .then((response) => {
        if (response && response.data.response_code === 80) {
          let transformedData = this.transFormLabelData(response.data.data);
          this.setState({ label_list: transformedData });
        } else {
          errorToast("Error", response.data.ui_message);
        }
      })
      .catch((error) => {
        errorToast("Error", error.message);
        reportError(error);
      });
  };
  handleSearchTypeChange = (selectedSearchType) => {
    if (!selectedSearchType) {
      this.setState({
        selectedSearchType: null,
        areSecondarySearchFieldsActive: false,
        selectedSearchValue: "",
      });
      return;
    }
    this.setState({
      selectedSearchType,
      areSecondarySearchFieldsActive: true,
      selectedSearchValue: "",
    });
  };
  handleValueChangeFromDropdown = (selectedSearchValue) => {
    this.setState({
      selectedSearchValue,
    });
  };
  handleDateChange = (name, date) => {
    if (name === "startDate" && !date) {
      this.setState({ [name]: date, endDate: null });
    } else {
      this.setState({
        [name]: date,
      });
    }
  };
  handleValueChangeFromTextBox = (e) => {
    this.setState({
      selectedSearchValue: e.target.value,
    });
  };
  handleStatusChange = (orderStatus) => {
    this.setState({
      orderStatus,
    });
  };
  getSearchValueDropdown = (selectedSearchType) => {
    console.log(
      `${selectedSearchType}_list`,
      this.state[`${selectedSearchType}_list`]
    );
    // TODO: Not a good way to do, but hacking for now
    return this.state[`${selectedSearchType}_list`] || [];
  };
  getSearchValueField = () => {
    const { selectedSearchType, selectedSearchValue } = this.state;
    if (
      selectedSearchType === "order_no" ||
      selectedSearchType === "reference_id" ||
      selectedSearchType === "external_id" ||
      selectedSearchType === "m_accn"
    ) {
      return (
        <div className="search-orders-field">
          <label className="search-orders-filter-label">Value</label>
          <Input
            className="search-orders-value-input"
            placeholder={PLACEHOLDER_MAPPING[selectedSearchType]}
            size="large"
            onChange={this.handleValueChangeFromTextBox}
            value={selectedSearchValue}
          />
        </div>
      );
    } else if (selectedSearchType !== "all_orders") {
      return (
        <div className="search-orders-field">
          <label className="search-orders-filter-label">Value</label>
          <Select
            showSearch
            className="search-orders-value-select"
            placeholder="Select value"
            value={selectedSearchValue || undefined}
            onChange={this.handleValueChangeFromDropdown}
            filterOption={(input, option) =>
              option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
              0
            }
          >
            {this.getSearchValueDropdown(selectedSearchType).map((item) => (
              <Option value={item.key} key={item.key}>
                {item.label}
              </Option>
            ))}
          </Select>
        </div>
      );
    }
    return null;
  };

  getDateSelectorsAndButtons = () => {
    const {
      selectedSearchValue,
      selectedSearchType,
      startDate,
      endDate,
    } = this.state;
    return (
      <div className="search-orders-dates-row">
        <div className="search-orders-field">
          <label className="search-orders-filter-label">Start date</label>
          <DatePicker
            className="search-orders-date-picker"
            placeholder="Start date"
            format="YYYY-MM-DD"
            disabledDate={(current) => current && current > moment().endOf("day")}
            onChange={(date) => this.handleDateChange("startDate", date)}
            value={startDate}
            size="large"
          />
        </div>
        <div className="search-orders-field">
          <label className="search-orders-filter-label">End date</label>
          <DatePicker
            className="search-orders-date-picker"
            placeholder="End date"
            format="YYYY-MM-DD"
            disabledDate={(current) => current && current > moment().endOf("day")}
            onChange={(date) => this.handleDateChange("endDate", date)}
            disabled={!startDate}
            value={endDate}
            size="large"
          />
        </div>
        <div className="search-orders-filter-actions">
          <Button
            className="search-orders-search-btn"
            disabled={
              selectedSearchType === "all_orders" ? false : !selectedSearchValue
            }
            type="primary"
            onClick={() => this.searchOrder("1")}
          >
            <Icon type="search" />
            Search
          </Button>
          <Button
            className="search-orders-clear-btn"
            onClick={this.clearSearch}
          >
            Clear
          </Button>
        </div>
      </div>
    );
  };
  exportOrder = () => {
    const {
      selectedSearchType,
      selectedSearchValue,
      orderStatus,
      startDate,
      endDate,
    } = this.state;

    const formatedStartDate = startDate ? startDate.format("YYYY-MM-DD") : null;
    const formatedEndDate = endDate ? endDate.format("YYYY-MM-DD") : null;
    successToast("Success", "You will shortly receive an email");
    exportOrder({
      selectedSearchType,
      selectedSearchValue,
      orderStatus,
      startDate: formatedStartDate,
      endDate: formatedEndDate,
    });
  };
  searchOrder = (pageNo) => {
    this.setState({
      loading: true,
    });
    const {
      selectedSearchType,
      selectedSearchValue,
      orderStatus,
      startDate,
      endDate,
    } = this.state;

    const formatedStartDate = startDate ? startDate.format("YYYY-MM-DD") : null;
    const formatedEndDate = endDate ? endDate.format("YYYY-MM-DD") : null;

    searchOrder({
      selectedSearchType,
      selectedSearchValue,
      orderStatus,
      startDate: formatedStartDate,
      endDate: formatedEndDate,
      pageNo,
    })
      .then((response) => {
        this.setState({
          orders: response,
          loading: false,
        });
      })
      .catch((e) => {
        this.setState({
          loading: false,
          error: e.message,
        });
        message.error("Oops! Some error occured");
      });
  };
  clearSearch = () => {
    this.setState({
      selectedSearchType: null,
      areSecondarySearchFieldsActive: false,
      selectedSearchValue: "",
      orderStatus: STATUS_TYPES[0].value,
      orders: {},
      startDate: "",
      endDate: "",
    });
  };

  render() {
    const {
      selectedSearchType,
      areSecondarySearchFieldsActive,
      loading,
      orders,
      orderStatus,
      startDate,
      endDate,
    } = this.state;
    const userPermissions = getUserPermissions();
    const results = (orders && orders.results) || [];
    const total = (orders && orders.count) || 0;
    const canExport =
      startDate !== "" &&
      endDate !== "" &&
      startDate !== null &&
      endDate !== null;

    return (
      <div className="search-orders-page">
        {this.props.loadingOrderData && (
          <SimplePageLoader label="Loading order…" />
        )}
        <Sidebar />
        <NavBar />
        <div className="search-orders-content">
          <header className="search-orders-hero">
            <div className="search-orders-hero__copy">
              <p className="search-orders-hero__eyebrow">Orders</p>
              <h1 className="search-orders-title">Search Orders</h1>
              <p className="search-orders-hero__subtitle">
                Find orders by status, reference, customer, product, and date range
              </p>
            </div>
            <PermissibleRender
              userPermissions={userPermissions}
              requiredPermissions={["can_export_data"]}
            >
              <Button
                className="search-orders-export-btn search-orders-export-btn--desktop"
                disabled={!canExport}
                type="primary"
                onClick={this.exportOrder}
              >
                <Icon type="download" />
                Export
              </Button>
            </PermissibleRender>
          </header>

          <section className="search-orders-filters" aria-label="Search filters">
            <div className="search-orders-field">
              <label
                className="search-orders-filter-label"
                htmlFor="search-order-status"
              >
                Order status
              </label>
              <Select
                id="search-order-status"
                className="search-orders-status-select"
                placeholder="Select status"
                value={orderStatus}
                onChange={this.handleStatusChange}
              >
                {STATUS_TYPES.map((statusType, index) => (
                  <Option key={index} value={statusType.value}>
                    {statusType.label}
                  </Option>
                ))}
              </Select>
            </div>

            <div className="search-orders-field">
              <label
                className="search-orders-filter-label"
                htmlFor="search-order-type"
              >
                Search by
              </label>
              <Select
                id="search-order-type"
                className="search-orders-type-select"
                placeholder="Select search type"
                value={selectedSearchType || undefined}
                onChange={this.handleSearchTypeChange}
                allowClear
              >
                {SEARCH_TYPES.map((searchType, index) => {
                  if (searchType.requiredPermissions.length > 0) {
                    if (
                      searchType.requiredPermissions.every(
                        (permission) =>
                          userPermissions.indexOf(permission) >= 0
                      )
                    ) {
                      return (
                        <Option key={index} value={searchType.value}>
                          {searchType.label}
                        </Option>
                      );
                    }
                    return null;
                  }
                  return (
                    <Option key={index} value={searchType.value}>
                      {searchType.label}
                    </Option>
                  );
                })}
              </Select>
            </div>

            {areSecondarySearchFieldsActive ? (
              <div className="search-orders-secondary">
                {this.getSearchValueField()}
                {this.getDateSelectorsAndButtons()}
              </div>
            ) : null}
          </section>

          <section className="search-orders-results" aria-label="Search results">
            <div className="search-orders-results-shell">
              <Table
                columns={this.columns}
                loading={loading}
                data={results}
                pagination={false}
                bordered={false}
                scroll={{ x: 1300 }}
                size="middle"
              />
              <div className="search-orders-pagination">
                <Paginater
                  defaultCurrent={1}
                  total={total}
                  onChange={this.searchOrder}
                  pageSize={DEFAULT_PAGE_SIZE}
                />
              </div>
            </div>
          </section>
        </div>
      </div>
    );
  }
}

const actions = {
  fetchOnHoldOrders,
  onHoldStatusChange,
  getOrderDetailsForPage,
  getOrderDetailsForForm,
  openModal,
  // fetchFormData
};
const mapStateToProps = (state) => ({
  loadingOrderData: state.home.loadingOrderData,
});
export default connect(
  mapStateToProps,
  actions
)(SearchOrders);
